<main class="parallel-main form-fields-sub-module">
	<div class="ff-row-form overflow-x-hidden">
		@if (
			!(
				outputConfig.childrenDependency &&
				!outputConfig.childrenDependency.controllDependency.visible
			)
		) {
			<div
				[ngClass]="'ff-field-size-' + outputConfig.history.size"
				class="ff-box-field"
				[class.slide-in-left]="
					outputConfig.childrenDependency &&
					!outputConfig.childrenDependency.controllDependency.exitMotion
				"
				[class.slide-out-left]="
					outputConfig.childrenDependency &&
					outputConfig.childrenDependency.controllDependency.exitMotion
				"
			>
				<lbca-gridbox
					class="w-full"
					[dataAttr]="atributesTask"
					[field]="outputConfig"
					[template]="outputConfig.template"
					[gridFormModuleInstance]="gridFormModuleInstance"
					[dynamicFormService]="dynamicFormService"
					[configuration]="outputConfig.configuration"
					[label]="outputConfig.label"
					[labeled]="true"
					[cardData]="cardInfo"
					[cleanUpData]="cleanUp"
					[disabled]="
						disabedControll ||
						outputConfig.disabled ||
						(outputConfig.childrenDependency &&
							outputConfig.childrenDependency.controllDependency.disabled)
					"
					[require]="outputConfig.required"
					(setError)="subFormModuleInstance(outputConfig.entityKey, 'error', $event)"
					(validState)="subFormModuleInstance(outputConfig.entityKey, 'valid', $event)"
					(changeValue)="changeValue($event)"
					[helperText]="outputConfig.helperText"
					[readonly]="outputConfig.readonly"
				></lbca-gridbox>
			</div>
		}
	</div>

	<!-- <div class="parallel-controlls" *ngIf="isSendTask">
  <button (click)="sendParallelRequests()" class="btn-primary btn-type-1 mr-[16px]">
    <span *ngIf="!loaderButton">Lançar Tarefas</span>
    <span *ngIf="loaderButton"><img class="forgot-loading" src="./assets/icons/loading-points.svg"/></span>
  </button>
</div> -->

	@if (loadHistory) {
		<div class="w-full text-xl ml-[24px] mb-[48px]">
			{{ outputConfig.history.label }}
		</div>
	}
	@if (!loadHistory && loaderButton) {
		<lbca-loading class="show z-[5000]" position="relative"></lbca-loading>
	}

	@if (loadHistory) {
		<lbca-table-list
			class="pb-[50px]"
			[field]="outputConfig.history"
			[disabled]="true"
			[dataAttr]="atributesTask"
			[cardData]="cardInfo"
			[body]="tableListData"
		></lbca-table-list>
	}
	@if (isReadonly && !loadHistory) {
		<lbca-body-feedback type="table-list" class="pb-[80px]">
			<ng-container tableMessagePrimary>
				Nenhuma informação para
				<br />
				visualizar
			</ng-container>
		</lbca-body-feedback>
	}
</main>
